import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { FieldModel } from '@cibo/core'
import { fieldOpportunitiesColumn, fieldStatusColumn } from '.'
import { FieldStatusChipProps } from '../FieldStatusChips'

export const useProgramColumns = ({
  onClickNeedsInfo,
  onClickOpportunity,
  onClickEnrolling,
  onClickEngaged,
  onClickProgram,
}: Pick<
  FieldStatusChipProps,
  'onClickNeedsInfo' | 'onClickProgram' | 'onClickEnrolling' | 'onClickEngaged'
> & {
  onClickOpportunity?(opportunity: { programId: string; field: FieldModel }): void
}) => {
  const { t } = useTranslation('@cibo/programs/FieldColumns')

  return useMemo(
    () => ({
      fieldStatusColumn: fieldStatusColumn({
        t,
        width: 180,
        onClickNeedsInfo,
        onClickEnrolling,
        onClickEngaged,
        onClickProgram,
      }),
      fieldOpportunitiesColumn: fieldOpportunitiesColumn({
        t,
        flex: 2,
        onClickNeedsInfo,
        onClickOpportunity,
      }),
    }),
    []
  )
}
